import Actions from '../actions'

export const closeLanguageModal = () => ({
  type: Actions.CLOSE_LANGUAGE_MODAL,
})

export const openLanguageModal = () => ({
  type: Actions.OPEN_LANGUAGE_MODAL,
})
